import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _SoundMaxLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", d: "M3.158 13.93a3.75 3.75 0 0 1 0-3.86 1.5 1.5 0 0 1 .993-.7l1.693-.339a.45.45 0 0 0 .258-.153L8.17 6.395c1.182-1.42 1.774-2.129 2.301-1.938S11 5.572 11 7.42v9.162c0 1.847 0 2.77-.528 2.962-.527.19-1.119-.519-2.301-1.938L6.1 15.122a.45.45 0 0 0-.257-.153l-1.693-.339a1.5 1.5 0 0 1-.993-.7Z" }),
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "M15.536 8.464a5 5 0 0 1 .027 7.044M19.657 6.343a8 8 0 0 1 .044 11.27" })));
}
const SoundMaxLight = forwardRef(_SoundMaxLight);
export { SoundMaxLight };
